/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OutreachChannel = {
    Email: 'email',
    StaffNotification: 'staff_notification',
    ManualLink: 'manual_link',
} as const;
export type OutreachChannel = typeof OutreachChannel[keyof typeof OutreachChannel];


export function instanceOfOutreachChannel(value: any): boolean {
    for (const key in OutreachChannel) {
        if (Object.prototype.hasOwnProperty.call(OutreachChannel, key)) {
            if (OutreachChannel[key as keyof typeof OutreachChannel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OutreachChannelFromJSON(json: any): OutreachChannel {
    return OutreachChannelFromJSONTyped(json, false);
}

export function OutreachChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutreachChannel {
    return json as OutreachChannel;
}

export function OutreachChannelToJSON(value?: OutreachChannel | null): any {
    return value as any;
}

export function OutreachChannelToJSONTyped(value: any, ignoreDiscriminator: boolean): OutreachChannel {
    return value as OutreachChannel;
}

